import actions from './actions';
const initState = {
    transactionReports: [],
    transactionReportsLoading: false,
    transactionReportsError: null,

    activationBatchReports: [],
    activationBatchReportsLoading: false,
    activationBatchReportsError: null,

    rechargeBatchReports: [],
    rechargeBatchReportsLoading: false,
    rechargeBatchReportsError: null,

    wifiBatchReports: [],
    wifiBatchReportsLoading: false,
    wifiBatchReportsError: null,

    transactionLedgerReport: [],
    transactionLedgerReportLoading: false,
    transactionLedgerReportError: null,

    fundManagementReport: [],
    fundManagementReportLoading: false,
    fundManagementReportError: null,

}

export default function reducer(state = initState, action) {
    switch (action.type) {

        case actions.TRANSACTION_REPORTS:
            return {
                ...state,
                transactionReports: [],
                transactionReportsLoading: true,
                transactionReportsError: null,
            };
        case actions.TRANSACTION_REPORTS_SUCCESS:
            return {
                ...state,
                transactionReportsLoading: false,
                transactionReports: action.payload.data,
            };
        case actions.TRANSACTION_REPORTS_FAILED:
            return {
                ...state,
                transactionReportsLoading: false,
                transactionReportsError: action.payload.error,
            };

        case actions.RESET_MESSAGE:
            return {
                ...state,
                transactionReportsLoading: false,
                transactionReportsError: null,
                transactionLedgerReportLoading: false,
                transactionLedgerReportError: null,
                fundManagementReportError: null,
            };


        case actions.RECHARGE_BATCH_REPORTS:
            return {
                ...state,
                rechargeBatchReports: [],
                rechargeBatchReportsLoading: true,
                rechargeBatchReportsError: null,
            };
        case actions.RECHARGE_BATCH_REPORTS_SUCCESS:
            return {
                ...state,
                rechargeBatchReportsLoading: false,
                rechargeBatchReports: action.payload.data,
                rechargeBatchReportsError: null,
            };
        case actions.RECHARGE_BATCH_REPORTS_FAILED:
            return {
                ...state,
                rechargeBatchReportsLoading: false,
                rechargeBatchReportsError: action.payload.error,
            };

        case actions.ACTIVATION_BATCH_REPORTS:
            return {
                ...state,
                activationBatchReports: [],
                activationBatchReportsLoading: true,
                activationBatchReportsError: null,
            };
        case actions.ACTIVATION_BATCH_REPORTS_SUCCESS:
            return {
                ...state,
                activationBatchReportsLoading: false,
                activationBatchReports: action.payload.data,
                activationBatchReportsError: null,
            };
        case actions.ACTIVATION_BATCH_REPORTS_FAILED:
            return {
                ...state,
                activationBatchReportsLoading: false,
                activationBatchReportsError: action.payload.error,
            };

        case actions.WIFI_BATCH_REPORTS:
            return {
                ...state,
                wifiBatchReports: [],
                wifiBatchReportsLoading: true,
                wifiBatchReportsError: null,
            };
        case actions.WIFI_BATCH_REPORTS_SUCCESS:
            return {
                ...state,
                wifiBatchReportsLoading: false,
                wifiBatchReports: action.payload.data,
                wifiBatchReportsError: null,
            };
        case actions.WIFI_BATCH_REPORTS_FAILED:
            return {
                ...state,
                wifiBatchReportsLoading: false,
                wifiBatchReportsError: action.payload.error,
            };

        case actions.TRANSACTION_LEDGER_REPORTS:
            return {
                ...state,
                transactionLedgerReport: [],
                transactionLedgerReportLoading: true,
                transactionLedgerReportError: null,
            };
        case actions.TRANSACTION_LEDGER_REPORTS_SUCCESS:
            return {
                ...state,
                transactionLedgerReportLoading: false,
                transactionLedgerReport: action.payload.data,
                transactionLedgerReportError: null,
            };
        case actions.TRANSACTION_LEDGER_REPORTS_FAILED:
            return {
                ...state,
                transactionLedgerReportLoading: false,
                transactionLedgerReportError: action.payload.error,
            };

        case actions.FUND_MANAGEMENT_REPORTS:
            return {
                ...state,
                fundManagementReport: [],
                fundManagementReportLoading: true,
                fundManagementReportError: null,
            };
        case actions.FUND_MANAGEMENT_REPORTS_SUCCESS:
            return {
                ...state,
                fundManagementReportLoading: false,
                fundManagementReport: action.payload.data,
            };
        case actions.FUND_MANAGEMENT_REPORTS_FAILED:
            return {
                ...state,
                fundManagementReportLoading: false,
                fundManagementReportError: action.payload.error,
            };

        default:
            return state;
    }
}